/* Breadcrumbs.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJFfAZ%7Bgrid-area%3Abreadcrumbs%7D%0A._0rIjyk1Y8M%7Bmargin-block-end%3Avar(--ds-space-050%2C4px)%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D");


import React from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
const compiledStyles = {
  root: "_1xC2CJFfAZ _0rIjyk1Y8M _4ouGXIdnbC"
};
export const Breadcrumbs = ({
  children
}: React.PropsWithChildren<unknown>): React.JSX.Element => {
  return <Box xcss={compiledStyles.root}>{children}</Box>;
};